export function getPathColor(alpha: number, isCaptureMode: boolean): string {
  return isCaptureMode ? 'black' : `hsla(180,20%,60%, ${alpha})`;
}
